<template>
  <v-dialog v-model="operationDetailsDialog" max-width="1280">
    <v-card>
      <v-card-title>
        <span>Operation Details</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
      <v-card-text v-else>
        <div class="d-flex flex-row">
          <div class="d-flex flex-column details-column">
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>ID</td>
                    <td>{{ operationDetails.id }}</td>
                  </tr>
                  <tr>
                    <td>Last Folder</td>
                    <td>{{ operationDetails.source_filepath | lastFolder }}</td>
                  </tr>
                  <tr>
                    <td>File Name</td>
                    <td>{{ operationDetails.source_filename }}</td>
                  </tr>
                  <tr>
                    <td>Job ID</td>
                    <td>{{ operationDetails.job_id }}</td>
                  </tr>
                  <tr>
                    <td>Classification</td>
                    <td>{{ operationDetails.classification }} & {{ operationDetails.state }}</td>
                  </tr>
                  <tr>
                    <td>File Path</td>
                    <td>{{ operationDetails.source_filepath | directoryPath }}</td>
                  </tr>
                  <tr>
                    <td>Device Type</td>
                    <td>
                      {{ operationDetails.type }}
                    </td>
                  </tr>
                  <tr>
                    <td>Date</td>
                    <!-- <td>
                      Completed: {{ operationDetails['completed-date'] }}<br>
                      <span>Checked: {{ operationDetails['checked-date'] }}</span><br>
                      <span>Prepared: {{ operationDetails['prepared-date'] }}</span>
                    </td> -->
                    <td>{{ operationDetails['fields']['prepared-date'] }}</td>
                  </tr>
                  <tr>
                    <td>Device</td>
                    <td>
                      {{ operationDetails.device_cleaned }}<br>
                      <span>{{ operationDetails.device }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Phase</td>
                    <td>
                      {{ operationDetails.phase || 'N/A' }}
                    </td>
                  </tr>
                  <tr>
                    <td>Location</td>
                    <td>
                      {{ operationDetails.location || 'N/A' }}
                    </td>
                  </tr>
                  <tr>
                    <td>Address</td>
                    <td>
                      {{ operationDetails.address || 'N/A' }}
                    </td>
                  </tr>
                  <tr>
                    <td>Operation</td>
                    <td>
                      {{ operationDetails.operation_category }}<br>
                      <span>{{ operationDetails.operation }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Full Sequence</td>
                    <td>N/A</td>
                  </tr>
                  <tr>
                    <td>Completed By</td>
                    <td>
                      {{ operationDetails.completed_by ? 'Yes' : 'No' }}
                    </td>
                  </tr>
                  <tr>
                    <td>Document Type</td>
                    <td>{{ operationDetails.type }}</td>
                  </tr>
                  <tr>
                    <td>Serial Number</td>
                    <td>{{ operationDetails.serial }}</td>
                  </tr>

                  <tr>
                    <td>Sequence #s</td>
                    <td>N/A</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
          <div class="flex-1 d-flex flex-column">
            <v-tabs v-model="previewTab" background-color="primary" class="flex-none" dark>
              <v-tab>Page</v-tab>
              <v-tab>Document</v-tab>
            </v-tabs>
            <v-tabs-items v-model="previewTab">
              <v-tab-item>
                <v-progress-linear v-if="pagePreviewLoading" indeterminate color="primary"></v-progress-linear>
                <img v-else-if="pagePreview" :src="pagePreview" class="image-container">
                <!-- <div class="image-container">
                  Preview
                </div> -->
                <!-- <v-img 
                  v-else-if="pagePreview" 
                  :src="pagePreview" 
                  @load="handlePagePreviewLoad" 
                  @error="handlePagePreviewError" 
                  contain
                  max-height="600px"
                />
                <div v-else class="pa-4 text-center">No page preview available</div> -->
              </v-tab-item>
              <v-tab-item>
                <v-progress-linear v-if="documentPreviewLoading" indeterminate color="primary"></v-progress-linear>
                <iframe
                  v-else-if="documentPreview"
                  :src="documentPreview + '#toolbar=0&navpanes=0'"
                  class="pdf-viewer"
                  type="application/pdf"
                  @load="handleDocumentPreviewLoad"
                  @error="handleDocumentPreviewError"
                ></iframe>
                <div v-else class="pa-4 text-center">No document preview available</div>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { getFirestore, doc, getDoc, collection } from "firebase/firestore";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
export default {

  // TODO: Fix the dialog preview spacing
  // TODO: Add the remaining fields to the table

  name: 'SwitchOrdersDetailsDialog',

  props: {
    operationId: {
      type: String,
      required: true
    }
  },
  
  data() {
    return {
      operationDetailsDialog: false,
      selectedOperationId: null,
      loading: false,
      operationDetails: null,
      previewTab: 0,
      pagePreview: null,
      documentPreview: null,
      pagePreviewLoading: false,
      documentPreviewLoading: false
    }
  },

  methods: {
    closeDialog() {
      this.operationDetailsDialog = false;
    },

    getOperationDetails(operationId) {
      if (this.operationDetails && this.operationDetails.id === operationId) return;
      this.operationDetails = null;
      this.previewTab = 0;
      this.pagePreview = null;
      this.documentPreview = null;
      this.loading = true;
      const db = getFirestore();
      const collectionRef = collection(db, 'op_switchorders_otos_operations');
      const operationRef = doc(collectionRef, operationId);
      getDoc(operationRef).then((doc) => {
        if (doc.exists()) {
          this.operationDetails = doc.data();
          this.operationDetails.id = operationId;
        } else {
          console.log('No such document!');
        }
      }).catch((error) => {
        console.error('Error getting document:', error);
      }).finally(() => {
        this.loading = false;
        this.getPagePreview(this.operationDetails.page_id);
        this.getDocumentPreview(this.operationDetails.source_filepath);
      });
    },

    getPagePreview(pageId) {  
      if (!pageId) {
        this.pagePreviewLoading = false;
        return;
      }
      this.pagePreviewLoading = true;
      const storage = getStorage();
      let path = 'operations/switchorders/pages/' + pageId + '.jpg';
      const pageRef = ref(storage, path);
      getDownloadURL(pageRef)
        .then((url) => {
          console.log('page path', path, url);
          this.pagePreview = url;
        })
        .catch((error) => {
          console.error('Error getting page preview:', error);
          this.pagePreview = null;
        })
        .finally(() => {
          this.pagePreviewLoading = false;
        });
    },

    getDocumentPreview(sourceFilePath) {
      if (!sourceFilePath) {
        this.documentPreviewLoading = false;
        return;
      }
      this.documentPreviewLoading = true;
      const storage = getStorage();
      let path = sourceFilePath.replace('0-raw', 'operations/switchorders/dataset');
      const documentRef = ref(storage, path);
      getDownloadURL(documentRef)
        .then((url) => {
          console.log('document path', path, url);
          this.documentPreview = url;
        })
        .catch((error) => {
          console.error('Error getting document preview:', error);
          this.documentPreview = null;
        })
        .finally(() => {
          this.documentPreviewLoading = false;
        });
    },

    handlePagePreviewLoad() {
      console.log("Page preview loaded successfully");
      this.pagePreviewLoading = false;
    },

    handlePagePreviewError(error) {
      console.error("Page preview failed to load:", error);
      this.pagePreviewLoading = false;
      this.pagePreview = null;
    },

    handleDocumentPreviewLoad() {
      console.log("Document preview loaded successfully");
      this.documentPreviewLoading = false;
    },

    handleDocumentPreviewError(error) {
      console.error("Document preview failed to load:", error);
      this.documentPreviewLoading = false;
      this.documentPreview = null;
    }

  },

  watch: {
    operationId: {
      async handler(newVal) {
        this.operationDetailsDialog = true;
        await this.getOperationDetails(newVal);
      }
    }
  },

  filters: {
    lastFolder(path) {
      const segments = path.split('/');
      // if last segment ends in .pdf then remove it
      if (segments[segments.length - 1].endsWith('.pdf')) {
        segments.pop();
      }
      return segments.pop() || '';
    },
    directoryPath(path) {
      const segments = path.split('/');
      segments.pop();
      return segments.join('/') || '';
    }
  }

}
</script>

<style lang="scss" scoped>
  .details-column {
    width: 400px;
    min-width: 400px;
    max-width: 400px;
    border-right: 1px solid #e0e0e0;
    margin-right: 1px;
  }
  .image-container {
    background-color: #f0f0f0;
    width: 100%;
    height: 100%;
  }
  .pdf-viewer {
    width: 100%;
    height: 600px;
    border: none;
  }
  .v-tabs-items {
    height: 100%;
    .v-window__container {
      height: inherit;
      .v-window-item {
        height: inherit;
      }
    }
  }
</style>